'use client';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { usePaybackLink } from '../../shared/usePaybackLink';

export const PaybackLink = () => {
  const { href, label } = usePaybackLink();
  return (
    <SlotEquivalentLinksItem href={href}>
      <span className="icon-emp-payback-colored size-4" aria-hidden />
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
